module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjEyIiB2aWV3Qm94PSIwIDAgMjAgMTIiIHdpZHRoPSIyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMzI1IDM1djJoMjB2LTJ6bTAtNXYyaDIwdi0yem0wLTV2MmgyMHYtMnoiIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMyNSAtMjUpIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/hamburger.svg
// module id = 140
// module chunks = 35783957827783 267625579013595